"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _QueueConfiguration_1 = require("./_QueueConfiguration");
exports._QueueConfigurationList = {
    type: "list",
    flattened: true,
    member: {
        shape: _QueueConfiguration_1._QueueConfiguration
    }
};
//# sourceMappingURL=_QueueConfigurationList.js.map